import { BodySmall, H2, Title4 } from "@components/Typography";
import { Button } from "@components/Button";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Backdrop, Modal } from "@contexts/ModalContext/styles";
import { Translations, i18n } from "@i18n";

import { ReserveRateInfoModalProps } from "./types";
import { useStyles } from "./styles";

const InfoItem = ({ label, subtitle }: { label: string; subtitle: string }) => (
  <div>
    <Title4>{label}</Title4>
    <Spacing size={SpacingSizes.XXS} />
    <BodySmall>{subtitle}</BodySmall>
  </div>
);

export const ReserveRateInfoModal = ({ show, onClose }: ReserveRateInfoModalProps) => {
  const styles = useStyles();

  const renderBackdrop = (props: any) => <Backdrop {...props} onClick={onClose} />;

  return (
    <Modal show={show} renderBackdrop={renderBackdrop}>
      <div style={styles.container}>
        <H2>{i18n.t(Translations.AccountTypeRouteReserveRateInfoModalTitle)}</H2>
        <Spacing size={SpacingSizes.L} />

        <div style={styles.item}>
          <InfoItem
            label={i18n.t(Translations.AccountTypeRouteReserveRateInfoModalTeyLabel)}
            subtitle={i18n.t(Translations.AccountTypeRouteReserveRateInfoModalTeySubtitle)}
          />
        </div>

        <div style={styles.item}>
          <InfoItem
            label={i18n.t(Translations.AccountTypeRouteReserveRateInfoModalIraMatchLabel)}
            subtitle={i18n.t(Translations.AccountTypeRouteReserveRateInfoModalIraMatchSubtitle)}
          />
        </div>

        <div style={styles.item}>
          <InfoItem
            label={i18n.t(Translations.AccountTypeRouteReserveRateInfoModalWelcomeBoostLabel)}
            subtitle={i18n.t(
              Translations.AccountTypeRouteReserveRateInfoModalWelcomeBoostSubtitle,
            )}
          />
        </div>

        <Spacing size={SpacingSizes.S} />
        <Button title={i18n.t(Translations.AccountTypeRouteReserveRateInfoModalCTA)} onClick={onClose} />
      </div>
    </Modal>
  );
};
